import isPast from "date-fns/isPast";

export const isExpired = (departureDateObject: Date) => (isPast(departureDateObject))